export const loadLogger = async () => {
  return (await import('lib/logger')).default;
};
